import { AssessmentData } from "./stub-response";

export const getAPIresponse = async () => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        let _data = AssessmentData;
        resolve(_data);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};

export const handleCloneAssessment = async (id) => {
  try {
    await new Promise((resolve) => {
      setTimeout(() => {
        let _data: any = {
          ...AssessmentData.assessments.filter(
            (assessment) => assessment.id == id
          )[0],
        };
        _data.id = new Date().getTime().toString();
        _data.name = `${_data.name} - (Clone)`;

        let updatedData = AssessmentData;
        updatedData.assessments = [_data, ...updatedData.assessments];

        resolve(updatedData);
      }, 1000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const handleUpdateAssessment = async (id, status) => {
  try {
    await new Promise((resolve) => {
      setTimeout(() => {
        let _data: any = AssessmentData.assessments.filter(
          (assessment) => assessment.id == id
        )[0];

        _data.status = status;

        resolve(AssessmentData);
      }, 1000);
    });
  } catch (error) {
    return Promise.reject(error);
  }
};

export const handleDelete = async (id) => {
  try {
    let response = await new Promise((resolve) => {
      setTimeout(() => {
        AssessmentData.assessments = AssessmentData.assessments.filter(
          (assessment) => assessment.id != id
        );

        resolve(AssessmentData);
      }, 1000);
    });
    return response;
  } catch (error) {
    return Promise.reject(error);
  }
};
